import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=52253552&scoped=true"
import script from "./pagination-table.vue?vue&type=script&lang=js"
export * from "./pagination-table.vue?vue&type=script&lang=js"
import style0 from "./pagination-table.vue?vue&type=style&index=0&id=52253552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52253552",
  null
  
)

export default component.exports